<template>
  <div>
    <div id="firebaseui-auth-container"></div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import firebaseui from 'firebaseui'

// prevent multiple firebaseui instances
let ui

// firebaseui config
const uiConfig = {
  signInSuccessUrl: '/user/profile',
  tosUrl: '/site/terms-of-service',
  privacyPolicyUrl: '/site/privacy-policy',
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID
  ]
}

export default {
  metaInfo: {
    title: 'Login'
  },
  created () {
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth())
    } else {
      ui.reset()
    }
  },
  mounted () {
    ui.start('#firebaseui-auth-container', uiConfig)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue